(() => {
  const selector = '[data-aleisha-animate]';
  const sectionSelector = '#MainContent .shopify-section';
  const visibleClass = 'is-aleisha-visible';
  const sectionVisibleClass = 'is-aleisha-section-visible';

  const revealAll = (root = document) => {
    root.querySelectorAll(sectionSelector).forEach((section) => section.classList.add(sectionVisibleClass));
    root.querySelectorAll(selector).forEach((element) => element.classList.add(visibleClass));
  };

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    revealAll();
    document.addEventListener('shopify:section:load', (event) => revealAll(event.target));
    return;
  }

  const elementObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add(visibleClass);
        elementObserver.unobserve(entry.target);
      });
    },
    {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12,
    }
  );

  const revealSection = (section) => {
    section.classList.add(sectionVisibleClass);

    window.requestAnimationFrame(() => {
      section.querySelectorAll(selector).forEach((element) => element.classList.add(visibleClass));
    });
  };

  const sectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        revealSection(entry.target);
        sectionObserver.unobserve(entry.target);
      });
    },
    {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.08,
    }
  );

  const watch = (root = document) => {
    const sections = [];

    if (root.matches?.('.shopify-section') && root.closest('#MainContent')) {
      sections.push(root);
    }

    root.querySelectorAll?.(sectionSelector).forEach((section) => sections.push(section));

    sections.forEach((section) => {
      const animatedElements = section.querySelectorAll(selector);
      if (!animatedElements.length) return;

      section.dataset.aleishaSectionReveal = '';
      section.classList.remove(sectionVisibleClass);
      animatedElements.forEach((element) => element.classList.remove(visibleClass));
      sectionObserver.observe(section);
    });

    root.querySelectorAll?.(selector).forEach((element) => {
      if (element.closest('[data-aleisha-section-reveal]')) return;
      element.classList.remove(visibleClass);
      elementObserver.observe(element);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => watch());
  } else {
    watch();
  }

  document.addEventListener('shopify:section:load', (event) => watch(event.target));
  document.addEventListener('shopify:section:reorder', () => watch(document));
  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest?.('[data-aleisha-section-reveal]');
    if (section) revealSection(section);
  });
})();
